




































































































































import { dateExportFormat, shortTimeAgo, dateTimeExportFormat } from '@/helpers/date-utils';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import { DISCOUNT_TYPE, OFFER_TYPE } from '@/store/shared';
import { ISession } from '@/store/types';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

const customActionMap: Record<string, string> = {
  handleCancel: 'Cancel',
  handlePause: 'Pause',
  handleContact: 'Contact',
  handleRedirect: 'Redirect',
  handleDiscount: 'Discount',
  handleTrialExtension: 'Trial Extension',
  handlePlanChange: 'Plan Change',
};

export default Vue.extend({
  name: 'SessionCard',
  mixins: [CopyToClipboard],
  props: {
    session: {
      type: Object as PropType<ISession>,
    },
  },
  data() {
    return {
      OFFER_TYPE,
      DISCOUNT_TYPE,
      shortTimeAgo,
      dateExportFormat,
      dateTimeExportFormat,
    };
  },
  computed: {
    ...mapGetters(['surveyChoices']),
    override() {
      if (this.session.customActionHandler) {
        const label = customActionMap[this.session.customActionHandler];
        const description = `Our default ${label.toLowerCase()} action has been overriden by your custom
          <pre class="text-green-500 text-sm font-mono inline-block mx-0.5"><code>${this.session.customActionHandler}</code></pre> function`;
        return {
          description,
          func: this.session.customActionHandler,
        };
      }
      return null;
    },
  },
  methods: {
    view(session: ISession) {
      this.$emit('view', session);
    },
  },
});
